<template>
  <div class='boxlog' id="boxlog">
    <!-- 筛选 -->
    <!-- <h3 class="flex-row-start" style="margin-top: 0">条件筛选</h3> -->
    
    <el-form @submit.native.prevent label-width='50px'>
      <el-row>
        <el-col :span="6">
          <el-form-item label='日期:'>
            <el-date-picker
              size="small"
              v-model="date"
              align="right"
              format="yyyy-MM-dd"
              @change='showtype = ""; getBoxlog()'
              :editable='false'
              :clearable='false'
              style="margin-left: 10px"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span='6' :offset="2">
          <el-form-item label='检索:'>
            <el-input v-model="keyword" size="small" @change="search" @keydown.enter="search">
              <template slot="append">
                <div style="cursor: pointer">搜索</div>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span='8' :offset="2">
          <el-button-group>
            <el-button size='small' :type="showtype == 'all' ? 'primary' : ''" @click="onTypeChange('all')">所有日志</el-button>
            <el-button size='small' :type="showtype == 'ble' ? 'primary' : ''" @click="onTypeChange('ble')">BLE数据</el-button>
            <el-button size='small' :type="showtype == 'ant' ? 'primary' : ''" @click="onTypeChange('ant')">ANT数据</el-button>
            <el-button size='small' :type="showtype == 'udp' ? 'primary' : ''" @click="onTypeChange('udp')">UDP数据</el-button>
          </el-button-group>
        </el-col>
      </el-row>
    </el-form>

    <i class="el-icon-arrow-up arrow-up" @click="scrollUp"></i>
    
    <!-- 盒子列表 -->
    <div class="flex-row-between">
      <h3 width='100px'>盒子日志：{{boxsn}}</h3>
    </div>
		
		<el-table :data='sessions_cloud' style='width: 100%' header-cell-class-name='myth' cell-class-name='mytd'
			v-loading="loading" size='medium' :expand-row-keys='expandKey' :row-key='row => row.id'
			ref="lessonrecord-table">
			<el-table-column label="SAAS课程ID">
				<template slot-scope="scope">
					{{scope.row.uuid.split('_')[1]}}
				</template>
			</el-table-column>
			<el-table-column prop='id' label="cloud课程ID" />
			<el-table-column label="上课区域">
				<template slot-scope="scope">
					{{scope.row.venue_area_uuid.split('_')[1]}}
				</template>
			</el-table-column>
			<el-table-column prop='name' :label="$t('课程名称')" />
			<el-table-column :label="$t('课程类型')">
				<template slot-scope="scope">
					{{classMap[scope.row.kind_no]}}
				</template>
			</el-table-column>
			<el-table-column label="教练">
				<template slot-scope="scope">
					{{scope.row.coach_uuid.split('_')[2] + ' - ' + scope.row.coach_name}}
				</template>
			</el-table-column>
			<!-- <el-table-column prop="coach_name" :label="$t('lessonrecord.教练')" /> -->
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-table :data='props.row.maps_session_customer' style='width: 100%' size='mini'
						header-row-class-name='expand-th' border>
						<!-- <el-table-column prop='customer_name' :label="$t('lessonrecord.姓名')"/> -->
						<el-table-column label="学员">
							<template slot-scope="scope">
								{{scope.row.customer_uuid.split('_')[2] + ' - ' + scope.row.customer_name}}
							</template>
						</el-table-column>
						<el-table-column :label="$t('性别')">
							<template slot-scope="scope">
								{{scope.row.sex == 1 ? $t('男') : $t('女')}}
							</template>
						</el-table-column>
						<!-- <el-table-column prop='phone_no' v-if="!is_abroad" :label="$t('lessonrecord.手机号')"/> -->
						<!-- <el-table-column prop='email' v-if="is_abroad" :label="$t('lessonrecord.邮箱')"/> -->
						<el-table-column prop='cle' sortable :label="$t('消耗卡路里')" />
						<el-table-column prop='ck' sortable :label="$t('CK值')" />
					</el-table>
				</template>
			</el-table-column>
			<el-table-column :label="$t('开始时间')" width='180'>
				<template slot-scope="scope">
					{{dateFormat(new Date(scope.row.create_dt))}}
				</template>
			</el-table-column>
			<el-table-column :label="$t('上课人数')">
				<template slot-scope="scope">
					{{scope.row.maps_session_customer.length}}
				</template>
			</el-table-column>
			<el-table-column :label="$t('操作')" width="320">
				<template slot-scope='scope'>
					<!-- <el-button @click='toggleRowExpansion(scope.row)' slot='reference' type='primary' size='mini'>
						{{$t('查看会员数据')}} <i style="font-size: 12px"
							:class="expandKey.indexOf(scope.row.id) != -1 ? 'take-icon-up' : 'take-icon-down'"></i>
					</el-button>
					<el-button type='danger' size="mini" @click="endSession(scope.row.uuid.split('_')[1])">强制下课
					</el-button> -->
				</template>
			</el-table-column>
		</el-table>
    <el-table
      :data='showdata'
      stripe
      style='width: 100%'
      border
      header-cell-class-name='myth'
      cell-class-name='mytd'
      v-loading="loading"
      size='small'
      v-if="showtype == 'all'"
    >
      <el-table-column
        type="index"
        width="100"
        :index='indexMethod'
      />
      <el-table-column
        prop='ip'
        label='IP'
      />
      <el-table-column
        label='cmd'
      >
        <template slot-scope='scope'>
          <el-tooltip :content="scope.row.cmd_desc" placement="bottom">
            <span style="cursor: pointer" >{{scope.row.cmd}}</span> 
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label='input_data'
      >
        <template slot-scope='scope'>
          {{scope.row.input_data}}
        </template>
      </el-table-column>
      <el-table-column
        prop='rst_msg'
        label='执行结果'
      />
      <el-table-column
        label='结果数据'
        min-width="240"
      >
        <template slot-scope='scope'>
          {{scope.row.rst_data}}
        </template>
      </el-table-column>
      <el-table-column
        prop='create_dt'
        label='时间'
        width='180'
      />
    </el-table>
    <el-table
      :data='device_hr_log'
      stripe
      style='width: 100%'
      border
      header-cell-class-name='myth'
      cell-class-name='mytd'
      v-loading="loading"
      size='small'
      v-if="showtype != 'all'"
    >
      <el-table-column
        label='cmd时间'
        width='160'
      >
        <template slot-scope='scope'>
          <div style="width: 100%; overflow: hidden; text-align: left">
            {{scope.row.cmd_time}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label='时间'
        width='160'
      >
        <template slot-scope='scope'>
          <div style="width: 100%; overflow: hidden; text-align: left">
            {{scope.row.time}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label='总数'
        width='100'
      >
        <template slot-scope='scope'>
          <div style="width: 100%; overflow: hidden; text-align: left">
            {{scope.row.total}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label='数据'
      >
        <template slot-scope='scope'>
          <div class="flex-row-start device-hr-detail">
            <div style="min-width: 110px; text-align: left; border-left: 1px solid rgb(50, 64, 87); padding-left: 4px" v-for="(item, index) in scope.row.detail.split(';')" :key="index">
              {{item}}
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { Loading } from 'element-ui'
  import { post, get } from '@/utils/http'
  import { format } from '@/utils/util'

  export default {
    data() {
      return {
        boxlog: [],
        form: {},
        loading: false,
        boxsn: this.$route.params.boxsn,
        date: [],
        keyword: '',
        showdata: [],
        showtype: 'all',
        device_hr_log: [],
		sessions_cloud: [],
		expandKey: []
      }
    },
    computed: {
      ...mapState(['user_id', 'unit_id', 'user_is_pta'])
    },
    mounted() {
      if (!this.boxsn) {
        this.$rouer.push('/boxlist')
      }
      this.date = new Date()
      this.getBoxlog()
	  this.getLessonlist()
    },
    methods: {
		async getLessonlist() {
			const res = await post('/index/Hide/queryRunningSession', data)
			console.log(res)
		},
      // 获取盒子列表
      async getBoxlog() {
        this.loading = true
        this.keyword = ''
        this.device_hr_log = []
        this.showtype = 'all'
        let y = this.date.getFullYear()
        let m = this.date.getMonth() + 1
        m = ('00' + m).substr(-2)
        let d = this.date.getDate()
        d = ('00' + d).substr(-2)
        const data = {
          sn: this.boxsn,
          date: y + '-' + m + '-' + d
        }
        try {
          const res = await post('/box/Index/getBoxLog', data)
          this.loading = false
          if (res && res.rst == 0) {
            let temp = '[' + res.data.replace(/\r\n/g, ',') + '{}]'
            temp = JSON.parse(temp)
            temp.pop()
            temp = temp.reverse()
            this.boxlog = temp
            this.showdata = temp
          }
        } catch(err) {
          this.loading = false
        }
      },
      scrollUp() {
        window.scrollTo(0, 0)
      },
      indexMethod(index) {
        return index + 1;
      },
      search() {
        this.loading = true
        setTimeout(() => {
          this.showdata = this.keyword ? this.boxlog.filter(b => b.cmd == this.keyword) : this.boxlog
        }, 0);
        setTimeout(() => {
          this.loading = false
        }, 500);
      },
      onTypeChange(value) {
        this.showtype = ''
        let loadingInstance = Loading.service()
        setTimeout(() => {
          this.showtype = value
          if (value != 'all') {
            this.device_hr_log = this.boxlog.filter(b => b.cmd == 'getVenueAreaSessionsStatus').reduce((a, b) => {
              let temp = b.input_data[value] ? b.input_data[value].split(';') : ''
              if (temp) {
                return [...a, {
                  time: temp[0],
                  total: temp[1],
                  detail: temp.slice(2).join(';'),
                  cmd_time: b.create_dt
                }]
              }
              return a
            }, [])
          }
          loadingInstance.close()
        }, 3000)
      }
    },
    name: 'boxlog'
  }
</script>
<style lang='less' scoped>
  .boxlog {
    .arrow-up {
      position: fixed;
      bottom: 64px;
      right: 32px;
      z-index: 999;
      color: #409EFF;
      font-size: 40px;
      font-weight: 700;
      cursor: pointer;
    }
    .device-hr-detail {
      width: 100%;
      overflow: scroll;
    }
    .device-hr-detail::-webkit-scrollbar {
      display: none;
    }
  }
</style>
